<template>
  <div v-if="screenData" class="sub-view analysis-zone">
    <div :class="['sub-view-wrapper', activeAside && 'opened']">
      <div class="sub-view-gabarit">
        <div class="header-box">
          <h4>{{ $t('sections.outlier') }}</h4>
          <p>{{ $t('sections.outlierDescription', { duration: study.sensitive_case_duration || 45 }) }}</p>
        </div>
        <Filters />
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.outlierFocus') }}</h5>
          </template>
          <template #body>
            <Focus :data="screenData" />
          </template>
        </AnalysisSection>
      </div>
      <FooterSection v-if="isDesktop" class="footer-section" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Analysis from './AnalysisMixin';
import Focus from '@/components/Analysis/Outlier/Focus';
import FooterSection from '@/components/Footer';

export default {
  components: {
    Focus,
    FooterSection,
  },

  mixins: [Analysis],

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
    }),
  },
};
</script>
